<template>
  <div class="h-100 fs-10">
    <div class="d-flex justify-content-between align-items-center p-2">
      <!--empty divs is needed, so the caption is centered -->
      <div />
      <div>
        <div class="d-inline-block me-3">
          <span class="bullet bg-aida-green" /><span class="bullet bg-aida-green" />
          Hin- & Rückflug
        </div>
        <div class="d-inline-block me-3">
          <div class="bullet bg-aida-green" /><div class="bullet bg-aida-red" />
          nur Hinflug
        </div>
        <div class="d-inline-block me-3">
          <div class="bullet bg-aida-red" /><div class="bullet bg-aida-green" />
          nur Rückflug
        </div>
        <div class="d-inline-block">
          <i class="fa fa-plane color-expinet-blue" />
          Inkl. AIDA-Flug
        </div>
      </div>
      <div />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    height: { type: String, default: '0px' },
  }
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.bullet {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-bottom: 1px;
  margin-right: 1px;
}
</style>
